import { gql, type TypedDocumentNode } from "@apollo/client";

export type UpdateSectionNotificationEmailsMutationData = {
  updateSectionNotificationEmails: {
    success: boolean;
    message: string;
    section: {
      id: string;
      contactEmail: string;
      notificationsEmail: string | null;
    } | null;
  };
};

export type UpdateSectionNotificationEmailsMutationVariables = {
  input: {
    sectionId: string;
    contactEmail: string;
    notificationsEmail: string;
  };
};

export const UPDATE_SECTION_NOTIFICATION_EMAILS_MUTATION: TypedDocumentNode<
  UpdateSectionNotificationEmailsMutationData,
  UpdateSectionNotificationEmailsMutationVariables
> = gql`
  mutation UpdateSectionNotificationEmails($input: BackofficeUpdateSectionNotificationEmailsInput!) {
    updateSectionNotificationEmails(input: $input) {
      success
      message
      section {
        id
        contactEmail
        notificationsEmail
      }
    }
  }
`;
